const launchpadData = [
 {
 id: 1,
 name:"Java Backend Developer",
 table:"sgl_javabacked",
 topics: [
"JPA",
"TestNG",
"JUnit",
"Performance Monitoring (JConsole)",
"Hibernate",
"Design Patterns",
"Maven",
"Spring Core",
"Gradle",
"Linux",
	"Performance Monitoring"
 ]
 },
 {
 id: 2,
 name:"Full Stack Web Developer (MERN)",
 table:"sgl_fullstack",
 topics: [
"Postman",
"Swagger",
"Deployment (Render)",
"Deployment (Vercel)",
"Express.js",
"HTML",
"Deployment (Heroku)",
"JS",
"MongoDB",
"CSS",
	"React.js",
"JWT Auth"
 ]
 },
 
 {
 id: 3,
 name:"Python Developer",
 table:"sgl_pythondeveloper",
 topics: [
"Unit Testing",
	"Deployment",
	"SQLite",
	"Flask",
	"Jinja2 Templates",
"Django",
	"Python",
	"CI CD (GitHub Actions)"
 ]
 },
 
 {
 id: 4,
 name:"Frontend Developer",
 table:"sgl_frontenddeveloper",
 topics: [
"Angular",
	"Responsive Design (Tailwind)",
	"HTML",
	"React Testing Library",
	"Figma to Code basics",
	"CSS",
	"React.js",
	"JavaScript",
	"Performance Optimization",
	"Responsive Design (Bootstrap)",
	"Webpack",
	"API Integration",
	"Vue.js"
 ]
 },
 {
 id: 5,
 name:"DevOps Engineer",
 table:"sgl_devops",
 topics: [
"CICD (GitHub Actions)",
	"Kubernetes Basics",
	"Bash Automation",
	"CICD (GitLab)",
	"CI CD (Jenkins)",
	"Monitoring Tools",
	"Shell Scripting",
	"Docker Compose",
	"Ansible",
	"Terraform",
	"AWS"
 ]
 },
 {
 id: 6,
 name:"QA/Automation Tester",
 table:"sgl_qa",
 topics: [
"Test Cases & Bug Reporting",
	"SQL",
	"Selenium with Java",
	"Selenium with Python",
	"Reporting Tools",
	"Manual Testing Basics",
	"TestNG",
	"API Testing",
	"JUnit"
 ]
 },
 {
 id: 7,
 name:"Data Analyst",
 table:"sgl_dataanalyst",
 topics: [
		"Data Visualization",
		"Python for Data Analysis",
		"Reporting Dashboards",
		"Data Cleaning Techniques",
		"Basic Statistics",
		"EDA",
		"SQL"
 ]
 },
 {
 id: 8,
 name:"Mobile App Developer (Flutter)",
 table:"sgl_mobileapp",
 topics: [
"Dart Programming",
"Flutter UI & Widgets",
"State Management (Provider / Bloc)",
"Firebase Integration (Auth, Firestore)",
"REST API Calls",
"Git & GitHub",
"Testing (Unit, Integration)",
"Deployment to Play Store",
"App Performance Optimization",
"Agile + Jira"
 ]
 },
 {
 id: 9,
 name:"Cybersecurity Analyst",
 table:"sgl_cybersecurity",
 topics: [
"Security Concepts",
	"Python Scripting",
	"Firewall",
	"Vulnerability Assessment",
	"Kali Linux",
	"Networking & Protocols",
	"Nmap/Wireshark",
	"Splunk",
	"SOC Tools",
	"IDS Basics"
 ]
 },
 {
 id: 10,
 name:"Cloud & SRE Engineer",
 table:"sgl_cloud",
 topics: [
"Load Balancing",
	"AWS",
	"Technology",
	"DNS",
	"CDN",
	"Incident Management",
	"Kubernetes",
	"Monitoring",
	"CloudFormation",
 ]
 },
 {
 id: 11,
 name:"AI Engineer",
 table:"sgl_aienginner",
 topics: [
"Deep Learning with TensorFlow",
	"Python for AI",
	"Computer Vision Image Processing",
	"Cloud AI Services",
	"Model Deployment",
	"Pandas",
	"Seaborn",
	"Matplotlib",
	"NLP",
	"Machine Learning Foundations",
	"Basic OOP",
	"MLOps Basics",
	"NumPy"
 ]
 },
 {
 id: 12,
 name:"Data Scientist",
 table:"sgl_datascientist",
 topics: [
		"Statistics & Probability",
		"Python for Data Analysis",
		"SQL for Data Science",
		"Machine Learning Essentials",
		"Data Wrangling & Cleaning",
		"Business Storytelling",
		"Data Visualization Tools",
		"Model Evaluation & Tuning",
		"Exploratory Data Analysis (EDA)"
 ]
 },
 {
 id: 13,
 name:"Blockchain Developer",
 table:"sgl_blockchain",
 topics: [
"Truffle",
	"Blockchain Security & Common Vulnerabilities",
	"Technology: Cryptography Essentials",
	"IPFS & Decentralized Storage",
	"Technology: NFT & Token Standards",
	"Smart Contract Development",
	"NFT & Token Standards",
	"Truffle Hardhat",
	"Hardhat",
	"dApp Development",
"Technology: Ethereum & Web3 Basics",
	"Blockchain Security",
	"Cryptography Essentials"
 ]
 },
 {
 id: 14,
 name:"Quantum Computing Learner",
 table:"sgl_quantumcomputing",
 topics: [
"Hybrid Classical–Quantum",
	"Technology: Industry Applications",
	"Quantum Error Correction",
	"Quantum Gates & Circuits",
	"Quantum Simulators",
	"Qiskit with Python",
	"Quantum Algorithms",
	"Qiskit notebooks + documentation writing",
	"Google Colab",
	"Linear Algebra Refresher"
 ]
 },
 {
 id: 15,
 name:"Edge Computing Specialist",
 table:"sgl_edgecomputing",
 topics: [
"Python for Edge (Serial Communication)",
	"AI on Edge Devices (TFLite)",
	"Data Streaming & Analytics",
	"Protocols",
	"Smart home automation",
	"MQTT/CoAP",
	"Edge Gateways & Fog Computing",
	"Networking & Security",
	"IoT Basics",
	"Raspberry Pi",
	"Smart meter",
	"Object Detection at Edge",
	"Arduino",
	"Technology",
	"Technology: Projects"
 ]
 },
 {
 id: 16,
 name:"Automation & RPA Developer",
 table:"sgl_automation",
 topics: [
"Error Handling & Logging",
	"Security & Compliance",
	"Introduction to RPA",
	"Email & Excel Automation",
	"Projects",
	"Bot Deployment & Scheduling",
	"Python",
	"Web Scraping",
	"UIPath Basics",
	"Automation Anywhere"
 ]
 },
 {
 id: 17,
 name:"GCP Cloud Engineer",
 table:"sgl_gcpcloud",
 topics: [
"Cloud Functions & App Engine",
	"Technology: Monitoring & Logging",
	"Cloud SQL & BigQuery",
	"GCP CLI & SDK",
	"Cloud Storage & Buckets",
	"Pub Sub & Cloud Scheduler",
	"Networking",
	"Compute Engine"
 ]
 },
 {
 id: 18,
 name:"Azure Cloud Associate",
 table:"sgl_azure",
 topics: [
"ARM Templates",
	"Networking",
	"Technology: Monitoring & Security",
	"Azure Functions",
	"Technology: Project & Deployment",
	"Azure SQL & Cosmos DB",
	"Project & Deployment",
	"Azure Blob Storage & Files",
	"Monitoring & Security",
	"Azure Compute",
	"Azure DevOps & Pipelines"
 ]
 },
 {
 id: 19,
 name:"Big Data Engineer",
 table:"sgl_hadoop",
 topics: [
"Airflow",
	"Kafka",
	"Capstone Project",
	"Apache Spark with PySpark",
	"Data Lake Design",
	"Hadoop Ecosystem Basics",
	"Sqoop & Flume",
	"Hive & HQL",
	"Cluster Monitoring"
 ]
 },
 {
 id: 20,
 name:"Data Analytics Professional",
 table:"sgl_dataanalytics",
 topics: [
	"Power BI basics",
	"A B Testing & Experiment",
	"Technology: Storytelling with Data",
	"Technology: SQL for Analysis",
	"Technology: Capstone Project",
	"Technology: Business Metrics & KPIs",
	"Storytelling with Data",
	"Technology: EDA",
	"Business Metrics & KPIs",
	"SQL for Analysis",
	"Python for Analysis",
	"Power BI Basics",
	"Google Data Studio"
 ]
 },
 {
 id: 21,
 name:"Cloud Support Engineer",
 table:"sgl_common",
 topics: [
"REST API",
	"Jira Basics",
	"Docker",
	"PostgreSQL",
	"GitHub",
	"Git",
	"Excel",
	"Google Sheets",
	"MySQL",
	"Agile Basics"
 ]
 }
];

export default launchpadData;



